// Modèle métier de la plateforme de veille (données de démonstration)
import {
  FaRegNewspaper,
  FaBroadcastTower,
  FaTv,
  FaHashtag,
  FaGlobe,
  FaBalanceScale,
} from "react-icons/fa";
import avatar1 from "assets/img/avatars/avatar1.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
import avatar4 from "assets/img/avatars/avatar4.png";
import avatar5 from "assets/img/avatars/avatar5.png";
import avatar6 from "assets/img/avatars/avatar6.png";
import avatar7 from "assets/img/avatars/avatar7.png";

/* ----------------------------- Référentiels ----------------------------- */

export const CANAUX = [
  { id: "presse", label: "Presse écrite", icon: FaRegNewspaper, desc: "Quotidiens, magazines, presse pro et régionale" },
  { id: "radio", label: "Radio", icon: FaBroadcastTower, desc: "Matinales, chroniques et flashs radio" },
  { id: "tele", label: "Télévision", icon: FaTv, desc: "JT, plateaux et émissions TV" },
  { id: "reseaux", label: "Réseaux sociaux", icon: FaHashtag, desc: "X, Bluesky, LinkedIn, Instagram, TikTok" },
  { id: "web", label: "Web & blogs", icon: FaGlobe, desc: "Sites d'actualité, blogs, forums et pure players" },
  { id: "juridique", label: "Juridique", icon: FaBalanceScale, desc: "Décisions de justice, textes légaux et sources officielles" },
];
export const canal = (id) => CANAUX.find((c) => c.id === id) || CANAUX[0];

export const FREQUENCES = [
  { id: "temps_reel", label: "Temps réel", detail: "Alerte dès qu'une mention est détectée", jours: [] },
  { id: "quotidien", label: "Quotidien", detail: "Un envoi chaque jour choisi", jours: ["lun", "mar", "mer", "jeu", "ven"] },
  { id: "bihebdomadaire", label: "Bi-hebdomadaire", detail: "Deux envois par semaine", jours: ["lun", "jeu"] },
  { id: "hebdomadaire", label: "Hebdomadaire", detail: "Un envoi par semaine", jours: ["lun"] },
  { id: "bimensuel", label: "Bi-mensuel", detail: "Deux envois par mois", jours: ["lun"] },
  { id: "mensuel", label: "Mensuel", detail: "Un bilan par mois", jours: ["lun"] },
  { id: "trimestriel", label: "Trimestriel", detail: "Un bilan par trimestre", jours: ["lun"] },
];
export const frequence = (id) => FREQUENCES.find((f) => f.id === id);

// Jours de la semaine (diffusion à la carte)
export const JOURS = [
  { id: "lun", court: "Lun", label: "Lundi" },
  { id: "mar", court: "Mar", label: "Mardi" },
  { id: "mer", court: "Mer", label: "Mercredi" },
  { id: "jeu", court: "Jeu", label: "Jeudi" },
  { id: "ven", court: "Ven", label: "Vendredi" },
  { id: "sam", court: "Sam", label: "Samedi" },
  { id: "dim", court: "Dim", label: "Dimanche" },
];
export const jour = (id) => JOURS.find((j) => j.id === id);

export const FORMATS = [
  { id: "synthese", label: "Synthèse exécutive", detail: "Note d'1 page : faits marquants + tonalité" },
  { id: "detaille", label: "Rapport détaillé", detail: "Toutes les retombées classées par canal" },
  { id: "dashboard", label: "Tableau de bord", detail: "Indicateurs et graphiques interactifs" },
  { id: "brut", label: "Flux brut", detail: "Export JSON / API de toutes les mentions" },
];
export const format = (id) => FORMATS.find((f) => f.id === id);

export const ROLES = [
  { id: "super_admin", label: "Super administrateur", detail: "Tous les droits admin ; ne peut être rétrogradé que par un autre super admin" },
  { id: "admin", label: "Administrateur", detail: "Gère l'équipe, la facturation et toutes les veilles" },
  { id: "manager", label: "Manager", detail: "Crée et attribue des veilles à son équipe" },
  { id: "analyste", label: "Analyste", detail: "Consulte et annote les veilles attribuées" },
  { id: "lecteur", label: "Lecteur", detail: "Accès en lecture seule aux rapports" },
];
export const role = (id) => ROLES.find((r) => r.id === id);

export const STATUTS = {
  active: { label: "En cours", color: "green" },
  programmee: { label: "Programmée", color: "blue" },
  terminee: { label: "Terminée", color: "gray" },
  en_pause: { label: "En pause", color: "orange" },
  brouillon: { label: "Brouillon", color: "gray" },
};
// Accès sûr : renvoie un statut par défaut si l'id est inconnu (évite les crashs)
export const statut = (id) => STATUTS[id] || { label: id || "—", color: "gray" };

/* ------------------------------- Veilles -------------------------------- */

export const VEILLES = [
  {
    id: "nordvpn",
    nom: "NordVPN — Réputation & cybersécurité",
    client: "NordVPN",
    secteur: "Cybersécurité / VPN",
    motsCles: ["NordVPN", "fuite de données", "vie privée", "chiffrement", "VPN gratuit"],
    canaux: ["presse", "reseaux", "web", "tele"],
    frequence: "quotidien",
    format: "synthese",
    statut: "active",
    responsable: "Camille Roy",
    prochaineDate: "Demain, 08:00",
    derniereDate: "Aujourd'hui, 08:00",
    mentions: 342,
    variation: 12.4,
    sentiment: { positif: 58, neutre: 31, negatif: 11 },
    couverture: 86,
    sources: 42,
    retombees: [
      { titre: "Une nouvelle norme de chiffrement saluée par les experts", source: "Le Monde", canal: "presse", date: "Il y a 2 h", tonalite: "positif" },
      { titre: "Débat sur les VPN gratuits : ce qu'il faut retenir", source: "France Inter", canal: "radio", date: "Il y a 5 h", tonalite: "neutre" },
      { titre: "Fil de discussion viral sur la confidentialité des données", source: "X (Twitter)", canal: "reseaux", date: "Il y a 8 h", tonalite: "negatif" },
      { titre: "Comparatif des solutions de protection en ligne", source: "01net", canal: "web", date: "Hier", tonalite: "positif" },
    ],
  },
  {
    id: "banquex",
    nom: "Banque X — Suivi crise & risques",
    client: "Banque X",
    secteur: "Banque / Finance",
    motsCles: ["Banque X", "frais bancaires", "arnaque", "service client", "taux"],
    canaux: ["presse", "radio", "tele", "reseaux", "web"],
    frequence: "temps_reel",
    format: "dashboard",
    statut: "active",
    responsable: "Camille Roy",
    prochaineDate: "En continu",
    derniereDate: "Il y a 12 min",
    mentions: 891,
    variation: 27.8,
    sentiment: { positif: 22, neutre: 41, negatif: 37 },
    couverture: 94,
    sources: 68,
    retombees: [
      { titre: "Vague de plaintes sur les frais bancaires", source: "Le Parisien", canal: "presse", date: "Il y a 1 h", tonalite: "negatif" },
      { titre: "Panne de l'appli mobile : les clients s'agacent", source: "X (Twitter)", canal: "reseaux", date: "Il y a 3 h", tonalite: "negatif" },
      { titre: "Le service client répond à la polémique", source: "BFM Business", canal: "tele", date: "Il y a 6 h", tonalite: "neutre" },
      { titre: "Analyse : la gestion de crise de Banque X", source: "Les Échos", canal: "presse", date: "Hier", tonalite: "neutre" },
    ],
  },
  {
    id: "greenfood",
    nom: "GreenFood — Lancement gamme bio",
    client: "GreenFood",
    secteur: "Agroalimentaire",
    motsCles: ["GreenFood", "bio", "circuit court", "nutri-score", "vegan"],
    canaux: ["presse", "reseaux", "web"],
    frequence: "hebdomadaire",
    format: "detaille",
    statut: "active",
    responsable: "Yanis Bernard",
    prochaineDate: "Lundi, 09:00",
    derniereDate: "Il y a 3 jours",
    mentions: 128,
    variation: 4.1,
    sentiment: { positif: 64, neutre: 28, negatif: 8 },
    couverture: 72,
    sources: 24,
    retombees: [
      { titre: "GreenFood mise sur le circuit court pour sa gamme bio", source: "LSA", canal: "presse", date: "Hier", tonalite: "positif" },
      { titre: "Le nutri-score de la nouvelle gamme fait débat", source: "Reddit", canal: "reseaux", date: "Il y a 2 j", tonalite: "neutre" },
      { titre: "Les influenceurs food adoptent la marque", source: "Instagram", canal: "reseaux", date: "Il y a 3 j", tonalite: "positif" },
    ],
  },
  {
    id: "electra",
    nom: "Electra — Mobilité électrique",
    client: "Electra Mobility",
    secteur: "Mobilité / Automobile",
    motsCles: ["Electra", "borne de recharge", "véhicule électrique", "autonomie"],
    canaux: ["presse", "web", "reseaux"],
    frequence: "hebdomadaire",
    format: "synthese",
    statut: "programmee",
    responsable: "Léa Marchand",
    prochaineDate: "12 juil., 09:00",
    mentions: 0,
    variation: 0,
    sentiment: { positif: 0, neutre: 0, negatif: 0 },
    couverture: 0,
  },
  {
    id: "festival",
    nom: "Festival Lumières — Édition 2026",
    client: "Ville de Lyon",
    secteur: "Culture / Événementiel",
    motsCles: ["Festival Lumières", "Lyon", "programmation", "affluence"],
    canaux: ["presse", "radio", "tele", "reseaux", "web"],
    frequence: "quotidien",
    format: "detaille",
    statut: "programmee",
    responsable: "Yanis Bernard",
    prochaineDate: "05 déc., 07:00",
    mentions: 0,
    variation: 0,
    sentiment: { positif: 0, neutre: 0, negatif: 0 },
    couverture: 0,
  },
  {
    id: "pharmavie",
    nom: "PharmaVie — Veille réglementaire",
    client: "PharmaVie",
    secteur: "Santé / Pharmaceutique",
    motsCles: ["PharmaVie", "AMM", "rappel de lot", "ANSM", "générique"],
    canaux: ["presse", "web", "juridique"],
    frequence: "hebdomadaire",
    format: "detaille",
    statut: "en_pause",
    responsable: "Léa Marchand",
    prochaineDate: "En pause",
    derniereDate: "Il y a 3 semaines",
    mentions: 54,
    variation: -6.2,
    sentiment: { positif: 40, neutre: 49, negatif: 11 },
    couverture: 61,
    sources: 15,
    retombees: [
      { titre: "Rappel de lot : l'ANSM précise la procédure", source: "Le Quotidien du Médecin", canal: "presse", date: "Il y a 4 j", tonalite: "neutre" },
      { titre: "Décision réglementaire sur les génériques", source: "Légifrance", canal: "juridique", date: "Il y a 1 sem", tonalite: "neutre" },
      { titre: "Les pharmaciens réagissent au rappel", source: "Le Moniteur des pharmacies", canal: "web", date: "Il y a 1 sem", tonalite: "negatif" },
    ],
  },
  {
    id: "retailco",
    nom: "RetailCo — Bilan campagne soldes",
    client: "RetailCo",
    secteur: "Retail / Distribution",
    motsCles: ["RetailCo", "soldes", "promotion", "e-commerce"],
    canaux: ["presse", "reseaux", "web"],
    frequence: "mensuel",
    format: "dashboard",
    statut: "terminee",
    responsable: "Camille Roy",
    prochaineDate: "—",
    derniereDate: "30 juin",
    mentions: 476,
    variation: 18.3,
    sentiment: { positif: 61, neutre: 27, negatif: 12 },
    couverture: 79,
    sources: 51,
    retombees: [
      { titre: "Bilan des soldes : RetailCo tire son épingle du jeu", source: "LSA", canal: "presse", date: "30 juin", tonalite: "positif" },
      { titre: "Campagne e-commerce saluée sur les réseaux", source: "LinkedIn", canal: "reseaux", date: "29 juin", tonalite: "positif" },
      { titre: "Comparatif des promotions de l'été", source: "01net", canal: "web", date: "28 juin", tonalite: "neutre" },
    ],
  },
  {
    id: "orbitai",
    nom: "OrbitAI — Levée de fonds série B",
    client: "OrbitAI",
    secteur: "Tech / Intelligence artificielle",
    motsCles: ["OrbitAI", "levée de fonds", "IA générative", "série B"],
    canaux: ["presse", "web", "reseaux"],
    frequence: "quotidien",
    format: "synthese",
    statut: "terminee",
    responsable: "Léa Marchand",
    prochaineDate: "—",
    derniereDate: "24 juin",
    mentions: 213,
    variation: 41.0,
    sentiment: { positif: 74, neutre: 21, negatif: 5 },
    couverture: 83,
    sources: 33,
    retombees: [
      { titre: "OrbitAI boucle une série B de 40 M€", source: "Les Échos", canal: "presse", date: "24 juin", tonalite: "positif" },
      { titre: "L'IA générative française monte en puissance", source: "X (Twitter)", canal: "reseaux", date: "23 juin", tonalite: "positif" },
      { titre: "Analyse : le pari d'OrbitAI sur l'IA souveraine", source: "Numerama", canal: "web", date: "22 juin", tonalite: "neutre" },
    ],
  },
];
export const getVeille = (id) => VEILLES.find((v) => v.id === id);
// Nombre de veilles dont une personne est responsable
export const veillesDe = (nom) => VEILLES.filter((v) => v.responsable === nom).length;

/* ------------------------------- Équipe --------------------------------- */

export const MEMBRES = [
  { id: "u1", nom: "Camille Roy", email: "c.roy@agence-veille.fr", role: "admin", statut: "actif", initiales: "CR", avatar: avatar1, veilles: 8, activite: "À l'instant" },
  { id: "u2", nom: "Yanis Bernard", email: "y.bernard@agence-veille.fr", role: "manager", statut: "actif", initiales: "YB", avatar: avatar2, veilles: 5, activite: "Il y a 20 min" },
  { id: "u3", nom: "Léa Marchand", email: "l.marchand@agence-veille.fr", role: "manager", statut: "actif", initiales: "LM", avatar: avatar3, veilles: 6, activite: "Il y a 2 h" },
  { id: "u4", nom: "Thomas Petit", email: "t.petit@agence-veille.fr", role: "analyste", statut: "actif", initiales: "TP", avatar: avatar4, veilles: 3, activite: "Hier" },
  { id: "u5", nom: "Sofia Nguyen", email: "s.nguyen@agence-veille.fr", role: "analyste", statut: "actif", initiales: "SN", avatar: avatar5, veilles: 4, activite: "Hier" },
  { id: "u6", nom: "Hugo Lefevre", email: "h.lefevre@agence-veille.fr", role: "lecteur", statut: "invite", initiales: "HL", avatar: avatar6, veilles: 1, activite: "Invitation envoyée" },
  { id: "u7", nom: "Inès Fontaine", email: "i.fontaine@agence-veille.fr", role: "lecteur", statut: "suspendu", initiales: "IF", avatar: avatar7, veilles: 0, activite: "Il y a 2 mois" },
];

// Utilisateur connecté (pour l'en-tête de profil)
export const MOI = MEMBRES[0];

export const STATUT_MEMBRE = {
  actif: { label: "Actif", color: "green" },
  invite: { label: "Invité", color: "blue" },
  suspendu: { label: "Suspendu", color: "gray" },
};
// Accès sûr au statut d'un membre
export const statutMembre = (id) => STATUT_MEMBRE[id] || { label: id || "—", color: "gray" };

/* ------------------------------- Alertes -------------------------------- */

export const ALERTES = [
  { id: "a1", nom: "Crise Banque X", veilleId: "banquex", condition: "Mots liés à une crise : fraude, piratage ou panne", motsCles: ["fraude", "piratage", "panne", "sécurité"], canaux: ["presse", "reseaux", "tele"], seuil: "Plus de 15 mentions par heure", notif: ["E-mail", "SMS", "Slack"], active: true, declenchements: 3 },
  { id: "a2", nom: "Pic de mentions NordVPN", veilleId: "nordvpn", condition: "Une faille ou une fuite de données est évoquée", motsCles: ["faille", "fuite de données", "vie privée"], canaux: ["reseaux", "web"], seuil: "Plus de 50 mentions par heure", notif: ["E-mail", "Push"], active: true, declenchements: 1 },
  { id: "a3", nom: "Rappel produit PharmaVie", veilleId: "pharmavie", condition: "Un rappel produit ou une décision de l'ANSM", motsCles: ["rappel", "ANSM", "effet indésirable"], canaux: ["presse", "web"], seuil: "Dès la première mention", notif: ["E-mail"], active: false, declenchements: 0 },
  { id: "a4", nom: "Bad buzz GreenFood", veilleId: "greenfood", condition: "Une vague de mentions négatives sur la marque", motsCles: ["bad buzz", "boycott", "scandale"], canaux: ["reseaux"], seuil: "Plus de 20 mentions négatives par heure", notif: ["E-mail", "Slack"], active: true, declenchements: 0 },
];

/* --------------------------- Utilisation / tokens ----------------------- */
// Un « token » = unité de consommation (une mention analysée, un rapport généré…).
export const UTILISATION = {
  plan: "Business",
  tokensInclus: 50000000,     // 50 millions de tokens pour 1 200 €
  tokensConsommes: 33750000,
  renouvellement: "1er août 2026",
  parVeille: [
    { veilleId: "banquex", tokens: 12800000 },
    { veilleId: "nordvpn", tokens: 7400000 },
    { veilleId: "orbitai", tokens: 5200000 },
    { veilleId: "retailco", tokens: 4100000 },
    { veilleId: "greenfood", tokens: 2600000 },
    { veilleId: "pharmavie", tokens: 1650000 },
  ],
};

export const PACKS = [
  { id: "p1", tokens: 10000000, prix: "290 €", detail: "Idéal pour un pic ponctuel" },
  { id: "p2", tokens: 50000000, prix: "1 200 €", detail: "Le plus choisi", populaire: true },
  { id: "p3", tokens: 100000000, prix: "2 100 €", detail: "Pour les gros volumes" },
];

export const FACTURES = [
  { id: "f1", date: "1 juil. 2026", libelle: "Abonnement Business — juillet", montant: "1 200 €", statut: "payee" },
  { id: "f2", date: "12 juin 2026", libelle: "Recharge 10 000 000 tokens", montant: "290 €", statut: "payee" },
  { id: "f3", date: "1 juin 2026", libelle: "Abonnement Business — juin", montant: "1 200 €", statut: "payee" },
];

// Format des grands nombres : 337500 -> "337 500"
export const fmtNombre = (n) => (typeof n === "number" ? n.toLocaleString("fr-FR") : n);

/* ------------------------------- Statistiques --------------------------- */

export const REPARTITION_CANAUX = [
  { canal: "reseaux", valeur: 41 },
  { canal: "presse", valeur: 34 },
  { canal: "web", valeur: 15 },
  { canal: "radio", valeur: 6 },
  { canal: "tele", valeur: 4 },
];

export const TOP_SOURCES = [
  { nom: "X (Twitter)", type: "Réseaux", mentions: 212, tonalite: "negatif" },
  { nom: "LinkedIn", type: "Réseaux", mentions: 87, tonalite: "positif" },
  { nom: "Le Monde", type: "Presse", mentions: 48, tonalite: "neutre" },
  { nom: "Les Échos", type: "Presse", mentions: 33, tonalite: "neutre" },
  { nom: "BFM TV", type: "Télévision", mentions: 19, tonalite: "neutre" },
  { nom: "France Inter", type: "Radio", mentions: 14, tonalite: "positif" },
];

export const TONALITE = {
  positif: { label: "Positif", color: "green" },
  neutre: { label: "Neutre", color: "gray" },
  negatif: { label: "Négatif", color: "red" },
};
// Accès sûr : renvoie une tonalité par défaut si l'id est inconnu
export const tonalite = (id) => TONALITE[id] || { label: id || "—", color: "gray" };

/* --------------------- Moteur de suggestions (mapping) ------------------ */

const REGLES = [
  { motifs: ["vpn", "cyber", "sécurit", "data", "hack", "rgpd", "privac"], s: {
    secteur: "Cybersécurité / Protection des données",
    motsCles: ["fuite de données", "vie privée", "chiffrement", "faille", "RGPD", "phishing"],
    canaux: ["presse", "reseaux", "web", "tele"], format: "synthese", frequence: "quotidien" } },
  { motifs: ["banque", "assur", "finance", "crédit", "invest", "bourse"], s: {
    secteur: "Banque / Finance / Assurance",
    motsCles: ["frais bancaires", "service client", "taux", "arnaque", "régulateur"],
    canaux: ["presse", "radio", "tele", "reseaux", "web"], format: "dashboard", frequence: "temps_reel" } },
  { motifs: ["bio", "alimen", "food", "resto", "nutri", "agro"], s: {
    secteur: "Agroalimentaire / Restauration",
    motsCles: ["bio", "circuit court", "nutri-score", "origine", "additifs"],
    canaux: ["presse", "reseaux", "web"], format: "detaille", frequence: "hebdomadaire" } },
  { motifs: ["santé", "pharma", "médic", "hôpital", "clinique", "soin"], s: {
    secteur: "Santé / Pharmaceutique",
    motsCles: ["AMM", "rappel de lot", "ANSM", "effet secondaire", "remboursement"],
    canaux: ["presse", "web", "juridique"], format: "detaille", frequence: "hebdomadaire" } },
  { motifs: ["juridi", "droit", "légal", "legal", "procès", "litige", "conformit", "réglement", "reglement", "justice", "contentieux"], s: {
    secteur: "Juridique / Conformité",
    motsCles: ["décision de justice", "litige", "conformité", "réglementation", "sanction"],
    canaux: ["presse", "web", "juridique"], format: "detaille", frequence: "hebdomadaire" } },
  { motifs: ["auto", "mobilit", "électr", "transport", "véhicule", "borne"], s: {
    secteur: "Mobilité / Automobile",
    motsCles: ["véhicule électrique", "borne de recharge", "autonomie", "bonus écologique"],
    canaux: ["presse", "web", "reseaux"], format: "synthese", frequence: "hebdomadaire" } },
  { motifs: ["ia", "intelligence", "tech", "startup", "logiciel", "saas", "app"], s: {
    secteur: "Tech / Intelligence artificielle",
    motsCles: ["IA générative", "levée de fonds", "innovation", "concurrent", "recrutement"],
    canaux: ["presse", "web", "reseaux"], format: "synthese", frequence: "quotidien" } },
];

const DEFAUT = {
  secteur: "Communication / Réputation de marque",
  motsCles: ["notoriété", "image de marque", "concurrent", "porte-parole"],
  canaux: ["presse", "reseaux", "web"], format: "synthese", frequence: "hebdomadaire",
};

export function suggererDepuisDemande(texte) {
  const t = (texte || "").toLowerCase();
  const regle = REGLES.find((r) => r.motifs.some((m) => t.includes(m)));
  return regle ? { ...regle.s } : { ...DEFAUT };
}

/* ---------------------- Document de mapping (généré) -------------------- */
// Construit le document de cadrage qui pilote la veille, à partir des données saisies.
export function genererMapping({ nom, client, secteur, demande, motsCles = [], canaux = [], sources = [], format: fmtId, frequence: freqId, destinataires, jours = [], heure } = {}) {
  const l = (id) => (canal(id) || {}).label || id;
  const dest = Array.isArray(destinataires) ? destinataires.filter(Boolean) : (destinataires ? [destinataires] : []);
  const joursLabel = (jours || []).map((j) => (jour(j) || {}).label || j).join(", ");
  const lignes = [
    "DOCUMENT DE MAPPING — VEILLE MÉDIA",
    "",
    `Client / marque suivie : ${client || "—"}`,
    `Intitulé de la veille : ${nom || "—"}`,
    `Secteur d'activité : ${secteur || "—"}`,
    "",
    "Objectif de la veille :",
    (demande || "—").trim(),
    "",
    `Mots-clés surveillés : ${motsCles.length ? motsCles.join(", ") : "—"}`,
    `Canaux couverts : ${canaux.length ? canaux.map(l).join(", ") : "—"}`,
    `Sources spécifiques : ${sources.length ? sources.join(", ") : "—"}`,
    "",
    `Format du rapport : ${(format(fmtId) || {}).label || "—"}`,
    `Fréquence d'envoi : ${(frequence(freqId) || {}).label || "—"}`,
    freqId !== "temps_reel" && joursLabel ? `Jours d'envoi : ${joursLabel}` : null,
    freqId !== "temps_reel" && heure ? `Heure d'envoi : ${heure}` : null,
    `Destinataires : ${dest.length ? dest.join(", ") : "—"}`,
  ].filter((x) => x !== null);
  return lignes.join("\n");
}
